var _styled;

// https://github.com/alphagov/govuk-frontend/tree/master/src/components/file-upload
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import Label from '@govuk-react/label';
import LabelText from '@govuk-react/label-text';
import ErrorText from '@govuk-react/error-text';
import HintText from '@govuk-react/hint-text';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, NTA_LIGHT, MEDIA_QUERIES } from '@govuk-react/constants';
var StyledInput = styled('input')((_styled = {
  boxSizing: 'border-box',
  fontFamily: NTA_LIGHT,
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  fontWeight: 400,
  textTransform: 'none',
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16,
  width: '50%'
}, _styled.width = '100%', _styled.padding = '5px 4px 4px', _styled));

var FileUpload = function FileUpload(_ref) {
  var meta = _ref.meta,
      children = _ref.children,
      hint = _ref.hint,
      acceptedFormats = _ref.acceptedFormats,
      className = _ref.className;
  return React.createElement(Label, {
    className: className,
    error: meta.error
  }, React.createElement(LabelText, {
    error: meta.error
  }, children), hint && React.createElement(HintText, null, hint), meta.touched && meta.error && React.createElement(ErrorText, null, meta.error), React.createElement(StyledInput, {
    type: "file",
    accept: acceptedFormats,
    error: meta.error
  }));
};

FileUpload.defaultProps = {
  hint: undefined,
  meta: {},
  acceptedFormats: undefined,
  className: undefined
};
FileUpload.propTypes = process.env.NODE_ENV !== "production" ? {
  hint: PropTypes.string,
  meta: PropTypes.shape({
    active: PropTypes.bool,
    dirty: PropTypes.bool,
    dirtySinceLastSubmit: PropTypes.bool,
    error: PropTypes.any,
    initial: PropTypes.bool,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitError: PropTypes.any,
    submitFailed: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    visited: PropTypes.bool
  }),
  children: PropTypes.node.isRequired,
  acceptedFormats: PropTypes.string,
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 6
})(FileUpload);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/file-upload/es/index.js
// module id = 79
// module chunks = 0